// Utilitare comune pentru rapoartele de Export CSV si Print, folosite pe mai
// multe pagini (Stoc curent, Miscari stoc, Produse finite).

// Formatare pentru rapoarte (Export/Print): mereu 2 zecimale, cu separator de
// mii - diferit intentionat de formatCantitate() (folosit in tabelele normale de
// pe ecran, care omite zecimalele inutile) - aici e nevoie de coloane aliniate,
// gata de calcul in Excel sau de citit pe hartie.
export function formatNumarRaport(valoare) {
  if (valoare == null || valoare === '') return '';
  const n = Number(valoare);
  if (Number.isNaN(n)) return String(valoare);
  return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Genereaza si descarca un fisier CSV. coloane: [{key, label}]. randuri: array de
// obiecte simple (deja formatate ca text, cu formatNumarRaport unde e nevoie) -
// cantitatea/um si pretul/valoarea trebuie sa fie coloane SEPARATE in randuri,
// nu combinate intr-un singur text (ca sa poata fi calculate direct in Excel).
export function exportaCSV(numeFisier, coloane, randuri) {
  const linii = [coloane.map(c => c.label).join(';')];
  randuri.forEach(r => {
    linii.push(coloane.map(c => {
      let v = r[c.key];
      if (v == null) v = '';
      v = String(v).replace(/"/g, '""');
      if (v.includes(';') || v.includes('"') || v.includes('\n')) v = `"${v}"`;
      return v;
    }).join(';'));
  });
  // BOM la inceput, ca Excel sa citeasca corect diacriticele romanesti.
  const continut = '\uFEFF' + linii.join('\r\n');
  const blob = new Blob([continut], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = numeFisier;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Deschide o fereastra noua cu un tabel HTML gata de printat. coloane:
// [{key, label, dreapta:true}] - "dreapta" aliniaza coloana la dreapta (pentru
// numere). randuri: obiecte cu valorile deja formatate ca text de afisat.
export function printeazaTabel(titlu, coloane, randuri, subtitlu) {
  const antet = coloane.map(c => `<th${c.dreapta ? ' style="text-align:right"' : ''}>${c.label}</th>`).join('');
  const corp = randuri.map(r => '<tr>' + coloane.map(c =>
    `<td${c.dreapta ? ' style="text-align:right"' : ''}>${r[c.key] ?? ''}</td>`
  ).join('') + '</tr>').join('');
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${titlu}</title>
    <style>
      body { font-family: Arial, sans-serif; padding: 24px; }
      h1 { font-size: 18px; margin-bottom: 2px; }
      p.sub { color: #666; font-size: 13px; margin-top: 0; }
      table { width: 100%; border-collapse: collapse; margin-top: 16px; }
      th, td { border: 1px solid #ccc; padding: 6px 10px; font-size: 13px; }
      th { background: #f0f2f5; text-align: left; }
    </style></head>
    <body>
      <h1>${titlu}</h1>
      <p class="sub">${subtitlu ? subtitlu + ' &middot; ' : ''}${new Date().toLocaleDateString('ro-RO')}</p>
      <table><thead><tr>${antet}</tr></thead><tbody>${corp}</tbody></table>
    </body></html>`;
  const fereastra = window.open('', '_blank');
  fereastra.document.write(html);
  fereastra.document.close();
  fereastra.print();
}
